import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_RECEIVED_STATUSES } from 'domains/seller-inventory-batch/constants'


const propTypes = {
  photo_received_status: PropTypes.string
}

/**
 * To give nice look on Seller Inventory Batch Item `photo_received_status`.
 * It maps `photo_received_status` to certain style and pass to `StatusBadge`.
 * @param {string} photo_received_status Seller Inbound Inventory Batch Items. available values
 * - `pending`
 * - `complete`
 */
const PhotoReceivedStatusBadge = ({ photo_received_status }) => {

  const colorMap = {
    [PHOTO_RECEIVED_STATUSES.PENDING]  : 'warning',
    [PHOTO_RECEIVED_STATUSES.COMPLETE] : 'success'
  }

  const color = colorMap[photo_received_status]

  return <StatusBadge color={ color } label={ photo_received_status } />
}

PhotoReceivedStatusBadge.propTypes = propTypes

export default PhotoReceivedStatusBadge